module.exports = __webpack_public_path__ + "img/140x140_placeholder_2.1bfc0a20.jpg";